import React from 'react';
import { Box } from '@mui/material';

interface IPartnerIconProps {
  path: string;
}

const PartnerIcon: React.FC<IPartnerIconProps> = ({ path }) => {
  return (
    <Box
      display='inline-block'
      width={21}
      height={21}
      mr={1}
      sx={{
        background: `url(${path}) no-repeat center / contain`,
        verticalAlign: 'middle',
      }}
    />
  );
};

export default PartnerIcon;
